<template>
<div>
    <b-row>

        <b-col md="6">
            <CCard>
                <CCardHeader color="primario" text-color="white">
                    <i class="fas fa-chart-bar"></i> <span class="h5"> Estadísticas </span>
                </CCardHeader>
                <CCardBody>
                    <span class="h6 text-muted">ESTADÍSTICAS DEL SISTEMA PARA LAS POLÍTICAS:
                    </span>
                    <hr>
                    <b-row class="justify-content-center text-center">
                        <b-col cols="12" class=" my-2 icon-custom">
                            <i style="inline-size: auto" class="ico fas fa-landmark fa-3x pb-1"></i>
                            <br>
                            <span class="lg-numero">{{listaPoliticas.length}}</span>
                            <br>
                            <span class="text-muted">Políticas registradas</span>
                        </b-col>
                    </b-row>
                </CCardBody>
            </CCard>
        </b-col>
        <b-col md="6">
            <CCard>
                <CCardHeader color="primario" text-color="white">
                    <i class="fas fa-cog"></i><span class="h5"> Gestión de políticas</span>
                </CCardHeader>
                <CCardBody>
                    <b-row class="justify-content-center text-center">
                        <b-col v-if="checkPermissions('017-37001-PPO','c') == 1" cols="4" class="my-2">
                            <b-button block variant="custom" @click="modalRegistrarPolitica = true">
                                <i style="inline-size: auto" class="fas fa-plus-circle fa-3x pb-1"></i><br><span>Nueva política</span>
                            </b-button>
                        </b-col>
                    </b-row>
                </CCardBody>
            </CCard>
        </b-col>
        <b-col md="12">
            <CCard>
                <CCardHeader color="primario" text-color="white">
                    <i class="fas fa-list fa-md"></i><span class="h5"> Políticas registradas </span>
                </CCardHeader>
                <CCardBody>
                    <b-row>
                        <b-col md="2">
                            <b-form-group label="Registros por página" class="text-muted">
                                <b-form-select size="xl" v-model="porPagina" :options="paginaOpciones"></b-form-select>
                            </b-form-group>
                        </b-col>
                        <b-col md="7">
                        </b-col>
                        <b-col md="3">
                            <b-form-group label="Busqueda:" class="text-muted">
                                <b-input-group size="xl">
                                    <b-input-group-prepend is-text>
                                        <i class="fas fa-search my-0 mx-0"></i>
                                    </b-input-group-prepend>
                                    <b-form-input type="search" v-model="filter" id="filterInput" placeholder="Buscar..."></b-form-input>
                                </b-input-group>
                            </b-form-group>
                        </b-col>
                        <b-col md="12">
                            <b-table bordered hover show-empty mediun responsive outlined :items="listaPoliticas" :fields="camposPoliticas" :current-page="paginaActual" :per-page="porPagina" :filter="filter" :filter-included-fields="filterOn" @filtered="onFiltered" empty-text="Aún no hay datos en esta sección." empty-filtered-text="No hay datos que coincidan con tu busqueda.">
                                <template v-slot:cell(index)="data">{{ data.index + 1 }}</template>
                                <template v-slot:cell(opciones)="param">
                                    <b-button v-if="checkPermissions('017-37001-PPO','u') == 1" size="sm" v-c-tooltip.hover.click="'Ver detalles'" @click="abrirModalActualizarPolitica(param)" variant="dark" class=" mr-1 mb-1">
                                        <span class="btn-inner--icon">
                                            <i class="fas fa-search my-0 mx-0"></i>
                                        </span>
                                    </b-button>
                                    <b-button v-if="checkPermissions('017-37001-PPO','d') == 1" size="sm" class="mr-1 mb-1" v-c-tooltip.hover.click="'Eliminar'" @click="eliminarPolitica(param)" variant="danger">
                                        <span class="btn-inner--icon">
                                            <i class="fas fa-trash-alt  my-0 mx-0"></i>
                                        </span>
                                    </b-button>
                                </template>
                                <template v-slot:cell(queEs)="param">
                                    <span v-if="param.item.queEs==1">Política</span>
                                    <span v-if="param.item.queEs==2">Norma</span>
                                    <span v-if="param.item.queEs==3">Código antisoborno</span>
                                </template>
                                <template v-slot:cell(revisado)="param">
                                    <span v-if="param.item.revisado==2">SI</span>
                                    <span v-if="param.item.revisado==1">NO</span>
                                </template>
                                <template v-slot:cell(aprobado)="param">
                                    <span v-if="param.item.aprobado==2">SI</span>
                                    <span v-if="param.item.aprobado==1">NO</span>
                                </template>
                            </b-table>
                        </b-col>
                    </b-row>
                </CCardBody>
                <CCardFooter>
                    <b-pagination size="sm" v-model="paginaActual" :total-rows="filasTotales" :per-page="porPagina" first-number last-number align="right" class="my-0"></b-pagination>
                </CCardfooter>
            </CCard>
        </b-col>
    </b-row>
    <CModal :show.sync="modalRegistrarPolitica" size="lg" color="primario">
        <template #header>
            <h6 class="modal-title">
                <i class="fas fa-plus-square fa-md"></i>
                <span class="h5"> Nueva política </span>
            </h6>
            <CButtonClose @click="modalRegistrarPolitica = false" class="text-white" />
        </template>
        <validation-observer ref="observer" v-slot="{ handleSubmit }">
            <b-form @submit.stop.prevent="handleSubmit(registrarPolitica)">
                <b-row>
                    <b-col md="12">
                        <validation-provider name="que es" >
                            <b-form-group label="Que es:" class="mb-2">
                                <b-form-radio-group plain v-model="datosPolitica.queEs" :options="[{value:1,text:'Política'},{value:2,text:'Norma'},{value:3,text:'Código antisoborno'}]"></b-form-radio-group>
                            </b-form-group>
                        </validation-provider>
                    </b-col>
                    <b-col md="6">
                        <validation-provider name="nombre" :rules="{required: true}" v-slot="validationContext">
                            <b-form-group label="Nombre:" class="mb-2">
                                <b-form-input :state="getValidationState(validationContext)" placeholder="Ingrese el nombre" v-model="datosPolitica.nombre"></b-form-input>
                                <b-form-invalid-feedback>{{ validationContext.errors[0] }}</b-form-invalid-feedback>
                            </b-form-group>
                        </validation-provider>
                    </b-col>
                    <b-col md="6">
                        <validation-provider name="versión" :rules="{required: true}" v-slot="validationContext">
                            <b-form-group label="Versión:" class="mb-2">
                                <b-form-input :state="getValidationState(validationContext)" placeholder="Ingrese la versión" v-model="datosPolitica.version"></b-form-input>
                                <b-form-invalid-feedback>{{ validationContext.errors[0] }}</b-form-invalid-feedback>
                            </b-form-group>
                        </validation-provider>
                    </b-col>
                    <b-col md="3">
                        <validation-provider name="revisado" >
                            <b-form-group label="Revisado:" class="mb-2">
                                <b-form-radio-group plain v-model="datosPolitica.revisado" :options="[{value:2,text:'SI'},{value:1,text:'NO'}]"></b-form-radio-group>
                            </b-form-group>
                        </validation-provider>
                    </b-col>
                    <b-col md="3">
                        <validation-provider name="aprobado">
                            <b-form-group label="Aprobado:" class="mb-2">
                                <b-form-radio-group plain v-model="datosPolitica.aprobado" :options="[{value:2,text:'SI'},{value:1,text:'NO'}]"></b-form-radio-group>
                            </b-form-group>
                        </validation-provider>
                    </b-col>
                    <b-col md="6">
                        <validation-provider name="responsable" :rules="{required: true}" v-slot="validationContext">
                            <b-form-group label="Responsable:" class="mb-2">
                                <b-form-input :state="getValidationState(validationContext)" placeholder="Ingrese el responsable" v-model="datosPolitica.responsable"></b-form-input>
                                <b-form-invalid-feedback>{{ validationContext.errors[0] }}</b-form-invalid-feedback>
                            </b-form-group>
                        </validation-provider>
                    </b-col>
                    <b-col md="12">
                        <validation-provider name="documento" v-slot="validationContext">
                            <b-form-group label="Documento:" class="mb-2">
                                <b-input-group>
                                    <b-input-group-prepend v-if="datosPolitica.urlDocumento != ''">
                                        <b-button variant="dark" class="px-2 py-0" @click="descargarDocumento(datosPolitica.urlDocumento)" v-c-tooltip="'Descargar'">
                                            <i class="fas fa-download fa-xs"></i>
                                        </b-button>
                                    </b-input-group-prepend>
                                    <b-form-file ref="file" class="text-left" v-model="datosPolitica.documento" v-on:change="handleFileUpload" :state="getValidationState(validationContext)" :placeholder="datosPolitica.nombreDocumento ? datosPolitica.nombreDocumento : 'Elija un archivo o arrástrelo aquí...'" :drop-placeholder="datosPolitica.nombreDocumento ? datosPolitica.nombreDocumento : 'Elija un archivo o arrástrelo aquí...'" browse-text="Subir"></b-form-file>
                                    <b-form-invalid-feedback>{{ validationContext.errors[0] }}</b-form-invalid-feedback>
                                </b-input-group>
                            </b-form-group>
                        </validation-provider>
                    </b-col>
                    <b-col md="12">
                        <validation-provider name="descripción" v-slot="validationContext">
                            <b-form-group label="Descripción:" class="mb-2">
                                <b-form-textarea v-model="datosPolitica.descripcion" :state="getValidationState(validationContext)" placeholder="Ingrese la descripción" rows="3" max-rows="6"></b-form-textarea>
                                <b-form-invalid-feedback>{{ validationContext.errors[0] }}</b-form-invalid-feedback>
                            </b-form-group>
                        </validation-provider>
                    </b-col>

                    <b-col md="12" class="text-right my-2">
                        <b-button :disabled="disabled" variant="success" class=" mr-2" type="submit">
                            Guardar
                        </b-button>
                        <b-button variant="danger" @click="modalRegistrarPolitica = false">
                            Cancelar
                        </b-button>
                    </b-col>
                </b-row>
            </b-form>
        </validation-observer>
        <template #footer>
            <span></span>
        </template>
    </CModal>

    <CModal :show.sync="modalActualizarPolitica" size="lg" color="primario">
        <template #header>
            <h6 class="modal-title"> <i class="fas fa-edit fa-md"></i>
                <span class="h5"> Actualizar política</span></h6>
            <CButtonClose @click="modalActualizarPolitica = false" class="text-white" />
        </template>
        <validation-observer ref="observer2" v-slot="{ handleSubmit }">
            <b-form @submit.stop.prevent="handleSubmit(actualizarPolitica)">
                <b-row>
                    <b-col md="12">
                        <validation-provider name="que es" >
                            <b-form-group label="Que es:" class="mb-2">
                                <b-form-radio-group plain v-model="datosActualizarPolitica.queEs" :options="[{value:1,text:'Política'},{value:2,text:'Norma'},{value:3,text:'Código antisoborno'}]"></b-form-radio-group>
                            </b-form-group>
                        </validation-provider>
                    </b-col>
                    <b-col md="6">
                        <validation-provider name="nombre" :rules="{required: true}" v-slot="validationContext">
                            <b-form-group label="Nombre:" class="mb-2">
                                <b-form-input :state="getValidationState(validationContext)" placeholder="Ingrese el nombre" v-model="datosActualizarPolitica.nombre"></b-form-input>
                                <b-form-invalid-feedback>{{ validationContext.errors[0] }}</b-form-invalid-feedback>
                            </b-form-group>
                        </validation-provider>
                    </b-col>
                    <b-col md="6">
                        <validation-provider name="versión" :rules="{required: true}" v-slot="validationContext">
                            <b-form-group label="Versión:" class="mb-2">
                                <b-form-input :state="getValidationState(validationContext)" placeholder="Ingrese la versión" v-model="datosActualizarPolitica.version"></b-form-input>
                                <b-form-invalid-feedback>{{ validationContext.errors[0] }}</b-form-invalid-feedback>
                            </b-form-group>
                        </validation-provider>
                    </b-col>
                    <b-col md="3">
                        <validation-provider name="revisado" >
                            <b-form-group label="Revisado:" class="mb-2">
                                <b-form-radio-group plain v-model="datosActualizarPolitica.revisado" :options="[{value:2,text:'SI'},{value:1,text:'NO'}]"></b-form-radio-group>
                            </b-form-group>
                        </validation-provider>
                    </b-col>
                    <b-col md="3">
                        <validation-provider name="aprobado">
                            <b-form-group label="Aprobado:" class="mb-2">
                                <b-form-radio-group plain v-model="datosActualizarPolitica.aprobado" :options="[{value:2,text:'SI'},{value:1,text:'NO'}]"></b-form-radio-group>
                            </b-form-group>
                        </validation-provider>
                    </b-col>
                    <b-col md="6">
                        <validation-provider name="responsable" :rules="{required: true}" v-slot="validationContext">
                            <b-form-group label="Responsable:" class="mb-2">
                                <b-form-input :state="getValidationState(validationContext)" placeholder="Ingrese el responsable" v-model="datosActualizarPolitica.responsable"></b-form-input>
                                <b-form-invalid-feedback>{{ validationContext.errors[0] }}</b-form-invalid-feedback>
                            </b-form-group>
                        </validation-provider>
                    </b-col>
                    <b-col md="12">
                        <validation-provider name="documento" v-slot="validationContext">
                            <b-form-group label="Documento:" class="mb-2">
                                <b-input-group>
                                    <b-input-group-prepend v-if="datosActualizarPolitica.urlDocumento != ''">
                                        <b-button variant="dark" class="px-2 py-0" @click="descargarDocumento(datosActualizarPolitica.urlDocumento)" v-c-tooltip="'Descargar'">
                                            <i class="fas fa-download fa-xs"></i>
                                        </b-button>
                                    </b-input-group-prepend>
                                    <b-form-file ref="fileActualizar" class="text-left" v-model="datosActualizarPolitica.documento" v-on:change="handleFileUploadActualizar" :state="getValidationState(validationContext)" :placeholder="datosActualizarPolitica.nombreDocumento ? datosActualizarPolitica.nombreDocumento : 'Elija un archivo o arrástrelo aquí...'" :drop-placeholder="datosActualizarPolitica.nombreDocumento ? datosActualizarPolitica.nombreDocumento : 'Elija un archivo o arrástrelo aquí...'" browse-text="Subir"></b-form-file>
                                    <b-form-invalid-feedback>{{ validationContext.errors[0] }}</b-form-invalid-feedback>
                                </b-input-group>
                            </b-form-group>
                        </validation-provider>
                    </b-col>
                    <b-col md="12">
                        <validation-provider name="descripción" v-slot="validationContext">
                            <b-form-group label="Descripción:" class="mb-2">
                                <b-form-textarea v-model="datosActualizarPolitica.descripcion" :state="getValidationState(validationContext)" placeholder="Ingrese la descripción" rows="3" max-rows="6"></b-form-textarea>
                                <b-form-invalid-feedback>{{ validationContext.errors[0] }}</b-form-invalid-feedback>
                            </b-form-group>
                        </validation-provider>
                    </b-col>

                    <b-col md="12" class="text-right my-2">
                        <b-button :disabled="disabled" variant="success" class=" mr-2" type="submit">
                            Guardar
                        </b-button>
                        <b-button variant="danger" @click="modalActualizarPolitica = false">
                            Cancelar
                        </b-button>
                    </b-col>
                </b-row>
            </b-form>
        </validation-observer>
        <template #footer>
            <span></span>
        </template>
    </CModal>
</div>
</template>

<script>
import axios from "axios";
import CONSTANTES from "@/Constantes.js";

export default {
    data() {
        return {
            disabled: false,
            listaPoliticas: [],
            camposPoliticas: [{
                    key: "index",
                    label: "N°",
                    class: "text-center",
                },
                {
                    key: "queEs",
                    label: "Que es",
                    class: "text-center",
                },
                {
                    key: "nombre",
                    label: "Nombre",
                    class: "text-center",
                },
                {
                    key: "version",
                    label: "Versión",
                    class: "text-center",
                },
                {
                    key: "revisado",
                    label: "Revisado",
                    class: "text-center",
                },
                {
                    key: "aprobado",
                    label: "Aprobado",
                    class: "text-center",
                },
                {
                    key: "responsable",
                    label: "Responsable",
                    class: "text-center",
                },
                {
                    key: "fecha",
                    label: "Fecha creación",
                    class: "text-center",
                },
                {
                    key: "opciones",
                    label: "",
                    class: "text-center",
                }
            ],

            filasTotales: 1,
            paginaActual: 1,
            porPagina: 10,
            paginaOpciones: [10, 25, 50, 100, {
                value: 9999999,
                text: "Mostrar todos"
            }],

            filter: null,
            filterOn: [],

            datosPolitica: {
                idCliente: '',
                queEs: 1,
                nombre: '',
                version: '',
                revisado: 2,
                aprobado: 2,
                responsable: '',
                descripcion: '',
                documento: null,
                urlDocumento: '',
                nombreDocumento: '',
                ejercicio: JSON.parse(localStorage.settings).yExcs,
            },
            datosActualizarPolitica: {
                idPolitica: '',
                idCliente: '',
                queEs: '',
                nombre: '',
                version: '',
                revisado: '',
                aprobado: '',
                responsable: '',
                descripcion: '',
                documento: null,
                urlDocumento: '',
                nombreDocumento: '',
                ejercicio: '',
            },
            modalRegistrarPolitica: false,
            modalActualizarPolitica: false,
        }
    },
    methods: {
        checkPermissions(code, crud) {
            return this.$store.state.permissions.filter(x => x.codigo == code)[0][crud]
        },
        onFiltered(itemsFiltrados) {
            this.filasTotales = itemsFiltrados.length
            this.paginaActual = 1
        },
        getValidationState({
            dirty,
            validated,
            valid = null
        }) {
            return dirty || validated ? valid : null;
        },
        handleFileUpload(e) {
            if (!e.target.files[0]) {
                return;
            } else {
                if (!e.target.files[0].name.match(/\.(xlsx|xls|csv|pdf|doc|docx|ppt|pptx|png|jpg|jpeg)$/i)) {
                    this.swat('error', "Formato de archivo no admitido.");
                    this.$refs["file"].reset();
                    return;
                }
                if (e.target.files[0].size > 20971520) {
                    this.swat('error', "El tamaño del archivo no debe ser superior a 20MB");
                    this.$refs["file"].reset();
                    return;
                }

                //this.listaOrganigramas.documento = this.$refs.file.files[0];
            }
        },
        handleFileUploadActualizar(e) {
            if (!e.target.files[0]) {
                return;
            } else {
                if (!e.target.files[0].name.match(/\.(xlsx|xls|csv|pdf|doc|docx|ppt|pptx|png|jpg|jpeg)$/i)) {
                    this.swat('error', "Formato de archivo no admitido.");
                    this.$refs["fileActualizar"].reset();
                    return;
                }
                if (e.target.files[0].size > 20971520) {
                    this.swat('error', "El tamaño del archivo no debe ser superior a 20MB");
                    this.$refs["fileActualizar"].reset();
                    return;
                }

                //this.listaOrganigramas.documento = this.$refs.file.files[0];
            }
        },
        descargarDocumento(url) {
            window.open(url)
        },
        listarPoliticas() {
            let me = this;
            axios.defaults.headers.common[
                "Authorization"
            ] = `Bearer ${localStorage.token}`;
            axios
                .get(
                    CONSTANTES.URL_RUTA_SERVICIOS + "coordinador/listar-politicas-sga", {
                        params: {
                            idCliente: me.datosPolitica.idCliente,
                            ejercicio: JSON.parse(localStorage.settings).yExcs,
                        },
                    }
                )
                .then(function (response) {
                    me.listaPoliticas = response.data;
                    me.filasTotales = me.listaPoliticas.length;
                })
                .catch(function (error) {
                    me.swat('error', 'Algo salió mal!')
                });
        },
        registrarPolitica() {
            let me = this;
            me.disabled = true;
            const formData = new FormData();
            formData.append("file", me.datosPolitica.documento);
            formData.append("folder", 'sga/publicacion-politicas');
            formData.append("datosPolitica", JSON.stringify(me.datosPolitica));
            axios
                .post(
                    CONSTANTES.URL_RUTA_SERVICIOS + "coordinador/registrar-politica-sga",
                    formData, {
                        headers: {
                            Authorization: `Bearer ${localStorage.token}`
                        }
                    }
                )
                .then(function (response) {
                    let color = response.data.resultado == 1 ? "success" : "error";
                    me.swat(color, response.data.mensaje)
                    me.modalRegistrarPolitica = false;
                    me.listarPoliticas();
                    me.disabled = false;
                })
                .catch(function (error) {
                    me.swat('error', 'Algo salió mal!')
                    me.disabled = false;
                });
        },
        actualizarPolitica() {
            let me = this;
            me.disabled = true;
            const formData = new FormData();
            formData.append("file", me.datosActualizarPolitica.documento);
            formData.append("folder", 'sgsi/publicacion-politicas');
            formData.append("datosPolitica", JSON.stringify(me.datosActualizarPolitica));
            axios
                .post(
                    CONSTANTES.URL_RUTA_SERVICIOS + "coordinador/registrar-politica-sga",
                    formData, {
                        headers: {
                            Authorization: `Bearer ${localStorage.token}`
                        }
                    }
                )
                .then(function (response) {
                    let color = response.data.resultado == 1 ? "success" : "error";
                    me.swat(color, response.data.mensaje)
                    me.modalActualizarPolitica = false;
                    me.listarPoliticas();
                    me.disabled = false;
                })
                .catch(function (error) {
                    me.swat('error', 'Algo salió mal!')
                    me.disabled = false;
                });
        },
        eliminarPolitica(param) {
            let me = this
            me.$swal.fire({
                title: '¿Estas seguro de eliminar la política?',
                text: "¡No podrás revertir esto!",
                icon: 'warning',
                showCancelButton: false,
                confirmButtonColor: '#d33',
                confirmButtonText: 'Eliminar',
            }).then((result) => {
                if (result.isConfirmed) {
                    let me = this;
                    axios
                        .post(
                            CONSTANTES.URL_RUTA_SERVICIOS + "coordinador/eliminar-politica-sga", {
                                idPolitica: param.item.idPolitica
                            }, {
                                headers: {
                                    Authorization: `Bearer ${localStorage.token}`
                                },
                            }
                        )
                        .then(function (response) {
                            let color = response.data.resultado == 1 ? "success" : "error";
                            me.swat(color, response.data.mensaje)
                            me.listarPoliticas();
                        })
                        .catch(function (error) {
                            me.swat('error', 'Algo salió mal!')
                        });
                }
            })
        },
        abrirModalActualizarPolitica(param) {
            this.datosActualizarPolitica.idPolitica = param.item.idPolitica;
            this.datosActualizarPolitica.queEs = param.item.queEs;
            this.datosActualizarPolitica.nombre = param.item.nombre;
            this.datosActualizarPolitica.version = param.item.version;
            this.datosActualizarPolitica.revisado = param.item.revisado;
            this.datosActualizarPolitica.aprobado = param.item.aprobado;
            this.datosActualizarPolitica.responsable = param.item.responsable;
            this.datosActualizarPolitica.descripcion = param.item.descripcion;
            this.datosActualizarPolitica.urlDocumento = param.item.urlDocumento;
            this.datosActualizarPolitica.nombreDocumento = param.item.nombreDocumento;
            this.datosActualizarPolitica.ejercicio = param.item.ejercicio;
            this.modalActualizarPolitica = true
        },

        swat(icon, title) {
            this.$swal.mixin({
                toast: true,
                showConfirmButton: false,
                position: 'bottom-right',
                timer: 3500,
                timerProgressBar: true,
                didOpen: (toast) => {
                    toast.addEventListener('mouseenter', this.$swal.stopTimer)
                    toast.addEventListener('mouseleave', this.$swal.resumeTimer)
                }
            }).fire({
                icon: icon,
                title: title
            });
        },
        resetModalRegistrarPolitica() {
            this.$nextTick(() => {
                this.$refs.observer.reset();
            });
            this.datosPolitica.queEs = 1;
            this.datosPolitica.nombre = '';
            this.datosPolitica.version = '';
            this.datosPolitica.revisado = 2;
            this.datosPolitica.aprobado = 2;
            this.datosPolitica.responsable = '';
            this.datosPolitica.documento = null;
            this.datosPolitica.descripcion = '';
        },
        resetModalActualizarPolitica() {
            this.$nextTick(() => {
                this.$refs.observer2.reset();
            });
            this.datosActualizarPolitica.documento = null;
        },
    },
    computed: {
        computedForm() {
            return this.$refs.observer;
        },
        computedActualizarForm() {
            return this.$refs.observer2;
        },
    },
    watch: {
        modalRegistrarPolitica: function (val) {
            if (val == false) {
                this.resetModalRegistrarPolitica();
            }
        },
        modalActualizarPolitica: function (val) {
            if (val == false) {
                this.resetModalActualizarPolitica();
            }
        }
    },
    mounted() {
        if (this.$store.state.user) {
            let user = this.$store.state.user;
            this.datosPolitica.idCliente = this.datosActualizarPolitica.idCliente = user.uidClient;
            this.listarPoliticas();
        }
    }

}
</script>
